<p-toast key="global" />
<router-outlet></router-outlet>
